//console.log('collectiv');

$(function() {

  //Slide 1 slide-1575294960984-2
  if($(window).width() >= 992) {
    $("#slide-1575294960984-2 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-1-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 991) {
    $("#slide-1575294960984-2 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-1-_1_-MH_3554c9df-8a39-4b40-85cd-1eeb72ec5284.jpg?v=1591170229");
  }
  
  if($(window).width() <= 575) {
    $("#slide-1575294960984-2 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-1-_1_-MH_89797ca5-483f-4daf-aec5-456ca88e8fc0.jpg?v=1591170228");

  }
  
  //Slide 2 slide-1575294960984-1
  
  if($(window).width() >= 992) {
    $("#slide-1575294960984-1 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-2-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 991) {
    $("#slide-1575294960984-1 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-2-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 575) {
    $("#slide-1575294960984-1 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-2-_1_-MH.jpg?v=1591170228");

  }
  
  //Slide 3 slide-1583236938987
  
  if($(window).width() >= 992) {
    $("#slide-1583236938987 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-3-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 991) {
    $("#slide-1583236938987 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-3-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 575) {
    $("#slide-1583236938987 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-3-_1_-MH.jpg?v=1591170228");

  }
  
  //Slide 4 slide-1575294960984-0
  
  if($(window).width() >= 992) {
    $("#slide-1575294960984-0 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-4-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 991) {
    $("#slide-1575294960984-0 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-4-_1_-MH.jpg?v=1591170229");
  }
  
  if($(window).width() <= 575) {
    $("#slide-1575294960984-0 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-4-_1_-MH2.jpg?v=1591259450");

  }
  
  $(window).resize(function(){
    
    //Slide 1 slide-1575294960984-2
    if($(window).width() >= 992) {
      $("#slide-1575294960984-2 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-1-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 991) {
      $("#slide-1575294960984-2 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-1-_1_-MH_3554c9df-8a39-4b40-85cd-1eeb72ec5284.jpg?v=1591170229");
    }

    if($(window).width() <= 575) {
      $("#slide-1575294960984-2 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-1-_1_-MH_89797ca5-483f-4daf-aec5-456ca88e8fc0.jpg?v=1591170228");
    }
    
    //Slide 2 slide-1575294960984-1 
    if($(window).width() >= 992) {
      $("#slide-1575294960984-1 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-2-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 991) {
      $("#slide-1575294960984-1 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-2-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 575) {
      $("#slide-1575294960984-1 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-2-_1_-MH.jpg?v=1591170228");

    }
    
    //Slide 3 slide-1583236938987
    if($(window).width() >= 992) {
      $("#slide-1583236938987 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-3-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 991) {
      $("#slide-1583236938987 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-3-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 575) {
      $("#slide-1583236938987 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-3-_1_-MH.jpg?v=1591170228");

    }

    //Slide 4 slide-1575294960984-0
    if($(window).width() >= 992) {
      $("#slide-1575294960984-0 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/1560px-Home-Banner-Rotation-4-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 991) {
      $("#slide-1575294960984-0 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/948px-Home-Banner-Rotation-4-_1_-MH.jpg?v=1591170229");
    }

    if($(window).width() <= 575) {
      $("#slide-1575294960984-0 .slide__image img").attr("src", "https://cdn.shopify.com/s/files/1/0270/8042/5506/files/575px-Home-Banner-Rotation-4-_1_-MH2.jpg?v=1591259450");

    }
  });
  
  
  $('.accordion').on('click', function(){
    let section = $(this).attr('id'),
        container = $('.accordion-wrapper').find("[data-section='" + section + "']");
    $('.accordion').removeClass('active');
    
    $('.accordion-wrapper .container').slideUp();
    if($(container).is(":hidden")){
      $(this).addClass('active')
      $(container).slideDown();
    }
  });
});


var setMax = 3;
$('.cart__form .qty').keypress(function() {
  if(parseInt($(this).val()) > setMax) {
    $(this).val(setMax);
  }
});

$('.actions .product__quantity button').on('click', function(e) {
  e.preventDefault();
  var btn = $(this);
  var oldValue = parseFloat(btn.parent().find("input").val());
  var min = btn.parent().find("input").attr('min');
  var max = btn.parent().find("input").attr('max');
  if(btn.hasClass('quantity__plus')) {
    if(oldValue < max) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      var newVal = max;
    }
   } else { 
    if(oldValue > min) {
      var newVal = parseFloat(oldValue) - 1;
    } else {
      var newVal = min;
    }
  }
  btn.parent().find("input").val(newVal);
  btn.parent().find("input").trigger('change');
});
